module.exports = __webpack_public_path__ + "static/media/FullLogo.d05c1e90.png";